import { render, staticRenderFns } from "./contentMain.vue?vue&type=template&id=f7170158&scoped=true&"
import script from "./contentMain.vue?vue&type=script&lang=js&"
export * from "./contentMain.vue?vue&type=script&lang=js&"
import style0 from "./contentMain.vue?vue&type=style&index=0&id=f7170158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7170158",
  null
  
)

export default component.exports